import { isNumberFormat } from "./isNumberFormat.ts";

/**
 * Decode URL + Trim before parsing to Int.
 * Useful to get correct id from URL.
 * Returns null instead of NaN (which is typeof "number")
 * Round floats 2.5 => 3
 */
export function toSafeInt(str?: string | null): number | null {
  if (str == null) return null;

  const safeStr = decodeURIComponent(str).trim();
  if (isNumberFormat(safeStr)) {
    return Number.parseInt(Number(safeStr).toFixed());
  } else {
    return null;
  }
}
